import React, { useState, useEffect } from 'react';
import currencyService from '../services/currencyService';

// Every currency picker in the portal, fed from the currency table (V580) so a new currency is a row, not a
// deploy. `billing` narrows it to the currencies HCONNECT charges in (Stripe prices, marketplace API cost).
//
// A value the list does not hold (an inactive code, or one stored before the table existed) is still offered,
// so opening and saving a record never silently changes its currency.
const CurrencySelect = ({ id, name, value, onChange, disabled, required, placeholder, billing, className }) => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    currencyService.getCurrencies(billing ? { billing: 'Y' } : {})
      .then(list => { if (!cancelled) setCurrencies(list); })
      .catch(err => {
        console.error('Error fetching currencies:', err);
        if (!cancelled) setError('Failed to load currencies');
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [billing]);

  if (loading) {
    return (
      <select id={id} name={name} className={className} disabled>
        <option>Loading currencies...</option>
      </select>
    );
  }

  if (error) {
    return (
      <select id={id} name={name} className={className} disabled>
        <option>Error loading currencies</option>
      </select>
    );
  }

  const codes = currencies.map(c => c.code);
  const options = value && !codes.includes(value) ? [...codes, value] : codes;

  return (
    <select
      id={id}
      name={name}
      className={className}
      value={value || ''}
      onChange={onChange}
      disabled={disabled}
      required={required}
    >
      {placeholder !== undefined && <option value="">{placeholder}</option>}
      {options.map(code => (
        <option key={code} value={code}>{code}</option>
      ))}
    </select>
  );
};

export default CurrencySelect;
